export const EXERCISE_LABELS: Record<TExercise, string> = {
  [TExercise.wordCards]: 'Word Cards',
  [TExercise.wordCardsReverse]: 'Translate',
};
